import { Link } from "react-router-dom";
import "./Ambassadors.css";
import SwirlIcon from "./components/SwirlIcon";

const perks = [
  {
    num: "₦500",
    txt: "per successful referral — your friend earns ₦500 too",
  },
  { num: "₦40k+", txt: "in level-up bonuses as you climb the ranks" },
  { num: "Kit", txt: "welcome pack, T-shirt, certificate & referral code" },
  {
    num: "Letter",
    txt: "founder recommendation letter + internship priority",
  },
];

const Recruit = () => {
  return (
    <div className="amb-page amb-recruit">
      <div className="amb-inner">
        <Link to="/ambassadors" className="amb-back">
          ← Back
        </Link>

        <div className="amb-top-row">
          <span className="amb-wordmark">
            squaay<span className="dot">.</span>
          </span>
          <SwirlIcon size={40} />
        </div>

        <div className="amb-headline">
          Be the <em>face</em>
          <br />
          of Squaay
          <br />
          on campus.
        </div>
        <div className="amb-sub">
          We're recruiting Campus Ambassadors — apply now.
        </div>

        <div className="amb-perks">
          {perks.map((perk) => (
            <div className="amb-perk" key={perk.num}>
              <div className="amb-perk-num">{perk.num}</div>
              <div className="amb-perk-txt">{perk.txt}</div>
            </div>
          ))}
        </div>

        <div className="amb-cta-band">
          <div className="amb-cta-band-inner">
            <div>
              <div className="amb-cta-text">
                Applications are <span>open now.</span>
              </div>
              <div className="amb-cta-link">
                Connecting food vendors and customers online.
              </div>
            </div>
            <Link to="/ambassadors/rewards" className="amb-pill">
              Apply now
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Recruit;
